(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    // Initialize: hide all content containers
    const allContentContainers = document.querySelectorAll('.msbc-content');
    const navItems = document.querySelectorAll('.msbn-item-inner');
    const defaultNavItem = document.getElementById('shop-by-collection');
    const defaultContent = document.getElementById('shop-by-collection-content');

    function resetToDefault() {
      navItems.forEach((item) => item.classList.remove('active'));
      allContentContainers.forEach((container) => {
        container.classList.remove('active');
        container.querySelectorAll('a, button').forEach(function(el) {
          el.setAttribute('tabindex', '-1');
        });
      });

      if (defaultNavItem && defaultContent) {
        defaultNavItem.classList.add('active');
        defaultContent.classList.add('active');
        defaultContent.querySelectorAll('a, button').forEach(function(el) {
          el.removeAttribute('tabindex');
        });
      }
    }

    // Initialize on load
    allContentContainers.forEach((container) => {
      container.classList.remove('active');
    });
    resetToDefault();

    // Add mouseleave handler to .megamenu to reset to default
    // Target the megamenu that contains the shop-by content
    const megamenuInnerNew = document.querySelector('.megamenu-inner_new');
    const megamenu = megamenuInnerNew ? megamenuInnerNew.closest('.megamenu') : null;
    if (megamenu) {
      let resetTimeout;
      megamenu.addEventListener('mouseleave', function () {
        resetTimeout = setTimeout(function () {
          resetToDefault();
        }, 400);
      });
      megamenu.addEventListener('mouseenter', function () {
        if (resetTimeout) {
          clearTimeout(resetTimeout);
        }
      });
    }

    function activateNavItem(navItem, moveFocus) {
      const navId = navItem.id;
      const contentId = navId + '-content';
      const targetContent = document.getElementById(contentId);

      if (!targetContent) return;

      navItems.forEach((item) => item.classList.remove('active'));
      allContentContainers.forEach((container) => {
        container.classList.remove('active');
        container.querySelectorAll('a, button').forEach(function(el) {
          el.setAttribute('tabindex', '-1');
        });
      });

      navItem.classList.add('active');
      targetContent.classList.add('active');
      targetContent.querySelectorAll('a, button').forEach(function(el) {
        el.removeAttribute('tabindex');
      });

      if (moveFocus) {
        var firstLink = targetContent.querySelector('a, button');
        if (firstLink) firstLink.focus();
      }
    }

    allContentContainers.forEach(function(container) {
      if (!container.classList.contains('active')) {
        container.querySelectorAll('a, button').forEach(function(el) {
          el.setAttribute('tabindex', '-1');
        });
      }
    });

    navItems.forEach((navItem) => {
      navItem.addEventListener('click', function () {
        activateNavItem(this, false);
      });
      navItem.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activateNavItem(this, true);
        }
      });
    });
  })();

  (function () {
    // Mobile megamenu panel navigation with full keyboard focus management.
    //
    // Panels slide in/out via CSS `right` transitions (not display:none), so
    // without intervention every focusable element in every panel stays in the
    // Tab order even while off-screen, trapping keyboard users.
    //
    // We use a triple-redundant guard because a single approach has failed in
    // the past (likely due to the `inert` attribute being silently unsupported
    // by certain browsers / builds, or other scripts stomping attributes):
    //   1. CSS `visibility: hidden` with a transition-delay equal to the slide
    //      animation. This is declarative, can't be overridden by JS, and is
    //      supported everywhere.
    //   2. `inert` attribute on inactive containers (modern browsers).
    //   3. Per-element `tabindex="-1"` on every focusable descendant of
    //      inactive containers, restored on reactivation. Works universally
    //      even in browsers that ignore `inert`.
    // Finally, focus is moved immediately on click so there is no gap where
    // the Tab key could land on the outgoing panel.

    var lastTrigger = null;  // the [data-mm-target] link that opened the current sub-panel
    var FOCUSABLE_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

    function deactivateFocusables(container) {
      if (!container) return;
      var els = container.querySelectorAll(FOCUSABLE_SELECTOR);
      els.forEach(function (el) {
        // Preserve any original tabindex so we can restore it.
        if (!el.hasAttribute('data-orig-tabindex')) {
          el.setAttribute('data-orig-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      });
    }

    function activateFocusables(container) {
      if (!container) return;
      var els = container.querySelectorAll(FOCUSABLE_SELECTOR);
      els.forEach(function (el) {
        var orig = el.getAttribute('data-orig-tabindex');
        if (orig === null) return;
        if (orig === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', orig);
        }
        el.removeAttribute('data-orig-tabindex');
      });
    }

    function setPanelInert(container, makeInert) {
      if (!container) return;
      if (makeInert) {
        container.setAttribute('inert', '');
        container.setAttribute('aria-hidden', 'true');
        deactivateFocusables(container);
      } else {
        container.removeAttribute('inert');
        container.removeAttribute('aria-hidden');
        activateFocusables(container);
      }
    }

    function focusFirstLinkIn(container) {
      if (!container) return;
      // Prefer the first link inside the main content area (not the back /
      // close buttons in the header).
      var contentArea = container.querySelector('.mm-inner-content') || container;
      var firstLink = contentArea.querySelector(
        'a[href]:not([tabindex="-1"]), button:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"])'
      );
      if (firstLink) {
        firstLink.focus();
        return;
      }
      // Fallback: the back button.
      var backBtn = container.querySelector('.mmih-left');
      if (backBtn) backBtn.focus();
    }

    function resetToBase(menuContainers, allContainersNoBase, baseContainer) {
      if (!baseContainer) return;
      menuContainers.forEach(function (c) { c.classList.remove('active'); });
      baseContainer.classList.add('active');
      baseContainer.classList.remove('slid');
      setPanelInert(baseContainer, false);
      allContainersNoBase.forEach(function (c) { setPanelInert(c, true); });
      lastTrigger = null;
    }

    function init() {
      var menuContainers = document.querySelectorAll('.mobile-menu-inner');
      var allContainersNoBase = document.querySelectorAll('.mobile-menu-inner:not(#mm-base)');
      var baseContainer = document.getElementById('mm-base');
      if (!baseContainer) return;

      // Reset to base state and lock down every sub-panel.
      resetToBase(menuContainers, allContainersNoBase, baseContainer);

      var menuOpenButton = document.querySelector('.menu-btn > button');
      if (menuOpenButton) {
        menuOpenButton.addEventListener('click', function () {
          resetToBase(menuContainers, allContainersNoBase, baseContainer);
        });
      }

      document.addEventListener('click', function (e) {
        var isKeyboardActivation = e.detail === 0;

        // ── Open sub-panel ────────────────────────────────────────────────
        var targetButton = e.target.closest('[data-mm-target]');
        if (targetButton) {
          e.preventDefault();
          var targetId = targetButton.getAttribute('data-mm-target');
          var targetContainer = document.getElementById(targetId);
          lastTrigger = targetButton;

          if (targetContainer) {
            // Lock every non-base panel (including target — reopened next).
            allContainersNoBase.forEach(function (c) {
              c.classList.remove('active');
              if (isKeyboardActivation) {
                setPanelInert(c, true);
              }
            });
            // Lock the base so Tab can't cycle back through it.
            if (isKeyboardActivation) {
              setPanelInert(baseContainer, true);
            }

            // Activate and unlock the target panel.
            targetContainer.classList.add('active');
            if (isKeyboardActivation) {
              setPanelInert(targetContainer, false);
            } else {
              targetContainer.removeAttribute('inert');
              targetContainer.removeAttribute('aria-hidden');
              activateFocusables(targetContainer);
            }
            baseContainer.classList.add('slid');

            // Move focus immediately so the user is never stranded on a
            // now-inert element while the animation plays.
            if (isKeyboardActivation) {
              focusFirstLinkIn(targetContainer);
            }
          }
          return;
        }

        // ── Close button (X) ──────────────────────────────────────────────
        var closeButton = e.target.closest('.menu-close');
        if (closeButton) {
          e.preventDefault();
          // Un-inert base first (same reason as back button — prevents focus
          // escaping to the page when the sub-panel becomes inert).
          baseContainer.classList.add('active');
          baseContainer.classList.remove('slid');
          setPanelInert(baseContainer, false);

          allContainersNoBase.forEach(function (c) {
            c.classList.remove('active');
            setPanelInert(c, true);
          });

          // Hand focus back to the hamburger so the user can reopen the menu.
          if (isKeyboardActivation) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                var hamburger = document.querySelector('.menu-btn > button');
                if (hamburger) hamburger.focus();
              });
            });
          }
          lastTrigger = null;
          return;
        }

        // ── Back button (←) ───────────────────────────────────────────────
        var backButton = e.target.closest('.mmih-left');
        if (backButton) {
          e.preventDefault();
          // Un-inert the base panel BEFORE locking the sub-panel.
          // When `inert` is added to a container the browser instantly moves
          // focus to the next focusable element in document order. If the base
          // container is still inert at that moment, focus escapes the menu
          // entirely. Restoring the base first means focus lands there instead.
          baseContainer.classList.add('active');
          baseContainer.classList.remove('slid');
          setPanelInert(baseContainer, false);

          allContainersNoBase.forEach(function (c) {
            c.classList.remove('active');
            setPanelInert(c, true);
          });

          lastTrigger = null;

          // Double-rAF ensures we're past both the CSS recalc and the
          // browser's own focus-relocation pass before we set focus ourselves.
          if (isKeyboardActivation) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                var firstBaseLink = baseContainer.querySelector('.mm-base-linkblock-wrap a[href], .mm-base-linkblock-wrap button');
                if (firstBaseLink) firstBaseLink.focus();
              });
            });
          }
          return;
        }
      });
    }

    // Run immediately if DOM is ready, otherwise wait for DOMContentLoaded.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["in-page-content_form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // need to maintain parent container height when form is submitted otherwise it will collapse and it looks bad
  // give it some time to load and then get the height
  let ipcfWrapHeight = null;
  setTimeout(function() {
    const ipcfWrap = document.querySelector('.ipcf-wrap');
    if (ipcfWrap) {
      ipcfWrapHeight = ipcfWrap.offsetHeight;
    }
  }, 1500);
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('btn') && e.target.classList.contains('btn-primary') && e.target.type === 'submit') {
      if (ipcfWrapHeight !== null && window.innerWidth > 768) {
        const ipcfWrap = document.querySelector('.ipcf-wrap');
        if (ipcfWrap) {
          ipcfWrap.style.height = ipcfWrapHeight + 'px';
        }
      }
      
      const observer = new MutationObserver(function(mutations, obs) {
        const submittedMessage = document.querySelector('.submitted-message');
        if (submittedMessage) {
          obs.disconnect();
          
          submittedMessage.remove();
          
          const formWrap = document.querySelector('.ipcf-form-wrap');
          if (formWrap) {
            formWrap.classList.add('hidden');
          }
          
          const submitted = document.querySelector('.ipcf-submitted');
          if (submitted) {
            submitted.classList.add('active');
          }
          
          // Scroll to top of form on mobile
          if (window.innerWidth <= 768) {
            const ipcfWrap = document.querySelector('.ipcf-wrap');
            if (ipcfWrap) {
              const rect = ipcfWrap.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetY = rect.top + scrollTop - 150;
              window.scrollTo({ top: targetY, behavior: 'smooth' });
            }
          }
        }
      });
      
      const formContainer = document.querySelector('.ipcf-form');
      if (formContainer) {
        observer.observe(formContainer, {
          childList: true,
          subtree: true
        });
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["megalinks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const headers = document.querySelectorAll('.link-columns_header[data-toggle]');

headers.forEach(header => {
header.addEventListener('click', function() {
const targetId = this.getAttribute('data-toggle');
const targetList = document.getElementById(targetId);
const isOpen = targetList.classList.contains('is-open');

// Toggle dropdown visibility
if (isOpen) {
targetList.classList.remove('is-open');
this.classList.remove('is-open');
} else {
targetList.classList.add('is-open');
this.classList.add('is-open');
}
});
});
});

  } catch(e) { console.error(e); }
})();
})();
